import React from "react";
import {app,db} from "./base";

function AddNav(){
    return(    
        <nav className="navbar navbar-dark bg-dark">
          <div className="navbar-brand navArea" id="main">
            <img src="logo.png" height="40" className="d-inline-block align-top pageIcon" alt="" loading="lazy"/>
            
          </div>
          <div className="buttonsBox">
          <button id="logout" className="btn btn-dark" onClick={() => app.auth().signOut()} type="logout">Logout</button>
          </div>
        </nav>
  )
}

function SearchClientForm({ filterClients }){
    const[value, setValue]=React.useState("")

    const searchClients=entry=>{
        setValue(entry);
        filterClients(entry);
    }

    return(            
        <div className="input-group mb-3">
                <input type="text" 
                    className="form-control" 
                    onChange={e=>{
                      searchClients(e.target.value.toLowerCase());
                    }}
                    placeholder="Enter Company"
                    aria-label="Recipient's username" 
                    aria-describedby="basic-addon2"/>
                <div className="input-group-append">

                </div>
 
        </div>
    )
}

const Home = () =>{
    const[clients,setClients]=React.useState([])
    const[matches,setMatches]=React.useState([])

    const filterClients=entry=>{
        let m=[]
        for(let client of clients){
            //if(client['name'].search(entry)!==-1 ||client['locations'].join().toLowerCase().search(entry)!==-1){
            if(client['name'].toLowerCase().search(entry)!==-1){
                m.push({'name':client['name'],'locations':client['locations']})
            }
        }
        setMatches(m)
    }

    //when the component mounts the first time
    React.useEffect(()=>{
        const fetchData=async()=>{
            const data = await db.collection("clients").get()
            setClients(data.docs.map(doc=>({...doc.data(),id: doc.id})))
            setMatches(data.docs.map(doc=>({...doc.data(),id: doc.id})))
        }
        fetchData()
    }, [])


    return(
        <>
            <AddNav></AddNav>
            <div className="container">
                <p><strong>***If you know anyone who could benefit from this, tell them to send me an email. - Moultrie***</strong></p>
                <SearchClientForm filterClients={filterClients}></SearchClientForm>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Company</th>
                            <th scope="col">Locations</th>
                            <th scope="col">Keywords</th>
                        </tr>
                    </thead>
                    <tbody>
                        {matches.map(match=>(
                            <tr key={match.name}>
                                <td>
                                    {match.name}
                                </td>
                                <td>
                                    {match.locations.join(', ')}
                                </td>
                                <td>
                                    None
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};


export default Home;